import { FC } from 'react';

import { Button } from 'components/parts/Button';

import styles from '../../Story.module.scss';
import { Screen } from '../Screen';

type Props = {
  step: number;
  handleNextStep: () => void;
  handlePrevStep: () => void;
  handleSkipDialogue: () => void;
};

/**
 * 第3章のストーリー
 */
export const ThirdStory: FC<Props> = ({
  step,
  handleNextStep,
  handlePrevStep,
  handleSkipDialogue,
}) => {
  if (step === 1) {
    return (
      <Screen
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        onSkipDialogue={handleSkipDialogue}
        hidePrevButton={true}
        hideNextButton={false}
        screen="sky"
      >
        <div className={[styles.bookRoot, styles.bookRootRight].join(' ')}>
          <img
            className={styles.book}
            src={require('../../images/book301.webp')}
            alt="暖かい日差しが差し込む福島にとある魔法使いが住んでいました。名前はアマナ。魔法を使って福島の人たちの役に立つことを目的とする機関「レッド・カウ」のリーダーです。つい最近まで、レッド・カウの仲間といえば、赤べこの姿をした精霊のフシマとアマナだけでした。しかし、先日の大冒険の中でレッド・カウの活動に賛同する4人の仲間、メーア・シエル・イスト・ライフンを得たのです。"
            width="367"
            height="545"
          />
        </div>
      </Screen>
    );
  }

  if (step === 2) {
    return (
      <Screen
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        onSkipDialogue={handleSkipDialogue}
        hidePrevButton={false}
        hideNextButton={false}
        screen="sky"
      >
        <div className={[styles.bookRoot, styles.bookRootLeft].join(' ')}>
          <img
            className={styles.book}
            src={require('../../images/book302.webp')}
            alt="5人と1匹は今、テーブルをかこんで座っています。みんなの視線はアマナに注がれています。なぜなら、レッド・カウの今後の働きについて、アマナがあるアイディアを発表しようとしていたからです。「あのね、これまで私たち、災いや争いが無くなって福島が幸せに包まれるように幸せの宝を探したり、人々がなくした宝物を代わりに探しに出かけたりしてきたでしょ。でもね……」みんなはゴクリとつばを飲み込みました。"
            width="367"
            height="545"
          />
        </div>
      </Screen>
    );
  }

  if (step === 3) {
    return (
      <Screen
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        onSkipDialogue={handleSkipDialogue}
        hidePrevButton={false}
        hideNextButton={false}
        screen="sky"
      >
        <div className={[styles.bookRoot, styles.bookRootRight].join(' ')}>
          <img
            className={styles.book}
            src={require('../../images/book303.webp')}
            alt="「今度は私たちの力を使って、福島中に宝を隠そうと思うの！」「ええ！僕たちが宝を隠すのあ？」フシマはビックリした様子です。「宝を探すんじゃなくて、隠すのか。なんだかおもしろそうだね」と、メーア。「何か理由があるんですか？」と、イスト。「それは……。たくさんの人が宝探しを終えた先にわかるはずよ！」とアマナはニッコリします。"
            width="367"
            height="545"
          />
        </div>
      </Screen>
    );
  }

  if (step === 4) {
    return (
      <Screen
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        onSkipDialogue={handleSkipDialogue}
        hidePrevButton={false}
        hideNextButton={true}
        screen="sky"
      >
        <div className={[styles.bookRoot, styles.bookRootLeft].join(' ')}>
          <img
            className={styles.book}
            src={require('../../images/book304.webp')}
            alt="こうしてレッド・カウのメンバーは、福島のあちこちに散らばり、宝を隠して回ることになったのです。そして、あなたたちのもとに「コード」――暗号を残したのでした。"
            width="367"
            height="545"
          />
        </div>
        <div className={styles.nextButton}>
          <Button text="OK" handleClick={handleSkipDialogue} />
        </div>
      </Screen>
    );
  }

  return null;
};
